export const FILTER = {
  EXPAND: "expand",
  COLLAPSE: "collapse",
};

export const HELP_AND_FAQ = "support:help and faq";